import axiosInstanceV2 from "../config/axios-v2-config";
import axiosInstance from "../config/axios-config";
import { toast } from "react-toastify";

const BASE_GENERIC_URL = "/v1/generic-drug";
const BASE_GENERIC_URL_V2 = "/v2/generic-drug";

export const getGenericNamesByCategoryNames = async (categoryId: string) => {
  try {
    const response = await axiosInstanceV2.get(
      `${BASE_GENERIC_URL_V2}category/${categoryId}`
      // {
      //   params: { categoryId: categoryId },
      // }
    );

    if (response.status !== 200) {
      throw Error("Unable retrieve generic name data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw Error("Unable retrieve generic name data");
  }
};

export const addNewGenericName = async ({
  genericName,
  categoryId,
}: {
  genericName: string;
  categoryId: string;
}) => {
  try {
    const response = await axiosInstanceV2.post(BASE_GENERIC_URL_V2, {
      name: genericName,
      category_id: categoryId,
    });
    if (response.status !== 201) {
      throw Error("Unable save Generic name data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw Error("Unable save Generic name data");
  }
};

export const updateGenericName = async ({
  id,
  name,
}: {
  id: string;
  name: string;
}) => {
  try {
    const response = await axiosInstanceV2.patch(
      `${BASE_GENERIC_URL_V2}/${id}`,
      {
        name: name,
      }
    );
    if (response.status !== 200) {
      toast.error("Unable to update generic name");
      throw Error("Unable to update generic name");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    toast.error("Unable to update generic name");
    throw Error("Unable to update generic name");
  }
};

export const deleteGenericName = async (id: string) => {
  try {
    const response = await axiosInstanceV2.delete(
      `${BASE_GENERIC_URL_V2}/${id}`
    );
    if (response.status !== 200 && response.status !== 204) {
      toast.error("Unable to delete generic name");
      throw Error("Unable to delete generic name");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    toast.error("Unable to delete generic name");
    throw Error("Unable to delete generic name");
  }
};
